export function fixturesAllowed(config: {production: boolean; name: string}): boolean {
  return !config.production && ['LOCAL', 'DEV', 'UAT'].includes(config.name);
}
